import * as types from '../constants/actionTypes';

export default function notification(state = {}, action) {

    switch (action.type) {
        case types.ADD_NOTIFICATION: {
            const {message, level, autoDismiss = 10} = action.payload;
            return Object.assign({}, state, {
                message,
                level,
                autoDismiss
            });
        }

        default: {
            return state;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/notificationReducer.js
 **/